// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"78":"f7390c79","455":"f7390c79"}[chunkId] + ".chunk.css";
};